<template>

  <div>

    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{$t('i18n.fota_update')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('i18n.version_mange')}}</el-breadcrumb-item>
      <el-breadcrumb-item > <span v-on:click="back" size='mini'>{{$t('i18n.column.upload_ota_package')}}</span></el-breadcrumb-item>
      <el-breadcrumb-item>
        <span v-on:click="back" size='mini'>{{$t('i18n.to_last_step')}}</span>
      </el-breadcrumb-item>

    </el-breadcrumb>

    <div class="app-container">
      <el-card class="filter-container" shadow="never">
        <span>{{ $t('i18n.span.fota_uploading', { projectName: projectName, currentVersionNo: currentVersionNo,updateVersionNo:updateVersionNo }) }}</span>
        <div style="margin-top: 15px">
        </div>
      </el-card>
    </div>
    <uploader browse_button="browse_button" :url="server_config.url+'/BigFile/'" chunk_size="2MB" :max_retries="1" :filters="{prevent_duplicates:true}" :FilesAdded="filesAdded" :BeforeUpload="beforeUpload" :Error="error" :UploadComplete="uploadComplete" :FileUploaded="fileUploaded" @inputUploader="inputUploader" />
    <br/>
    <br/>
    <el-button type="primary" round id="browse_button">{{$t('i18n.choose_file')}}</el-button>
    <el-button :disabled="uploading" type="primary" round @click="uploadStart()">{{$t('i18n.upload_start')}}</el-button>
    <el-button :disabled="!uploading" type="warring" round @click="uploadStop()">{{$t('i18n.upload_pause')}}</el-button>
    <br/>
    <el-table :data="tableData" style="width: 100%; margin: 10px 10px;">
      <el-table-column :label="$t('i18n.column.file_name')">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('i18n.column.file_size')">
        <template slot-scope="scope">
          <span>{{scope.row.size}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('i18n.column.current_status')">
        <template slot-scope="scope">
          <span v-if="scope.row.status === -1">{{ $t('i18n.loading_data')}}</span>
          <span v-if="scope.row.status === 1 && scope.row.percent === 0" style="color: orange">{{ $t('i18n.loading_ok_upload')}}</span>
          <span v-if="scope.row.status === 4" style="color: brown">{{ $t('i18n.upload_fail')}}</span>
          <span v-if="scope.row.status === 5" style="color: blue">{{ $t('i18n.upload_ok')}}</span>
          <el-progress v-if="scope.row.status === 2 || scope.row.status === 1 && scope.row.percent > 0" :text-inside="true" :stroke-width="20" :percentage="scope.row.percent"></el-progress>
        </template>
      </el-table-column>
      <el-table-column :label="$t('i18n.column.operator')">
        <template slot-scope="scope">
          <el-button type="danger" round @click="deleteFile(scope.row.id)">{{ $t('i18n.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br/>

  </div>
</template>

<script>
import FileMd5 from '@/models/file-md5.js';
import Uploader from '@/components/upload/Uploader';
import { updateVersionDetailStatus, updateVersionDetail } from '@/api/versionDetail';
export default {
    name: 'FotaUpload',
    data() {
        return {
            server_config: this.global.server_config,
            up: {},
            files: [],
            tableData: [],
            uploading: false,
            projectName: '',
            currentVersionNo: '',
            updateVersionNo: '',
            updateVersionDetail: {
                detailId: null,
                status: null,
                fileName: null,
                fileSize: null,
                size:null,
                downloadUrl: null,
                md5: null
            }
        };
    },
    components: {
        uploader: Uploader
    },
    watch: {
        $route(to, from) {
            this.currentVersionId = this.$route.query.currentVersionId;
            this.currentVersionNo = this.$route.query.currentVersionNo;
            this.updateVersionNo = this.$route.query.updateVersionNo;
            this.projectName = this.$route.query.projectName;
        },
        files: {
            handler() {
                this.tableData = [];
                this.files.forEach(e => {
                    this.tableData.push({
                        name: e.name,
                        size: e.size,
                        status: e.status,
                        id: e.id,
                        percent: e.percent,
                        md5: e.md5
                    });
                });
            },
            deep: true
        }
    },
    created() {
        this.getParam(); //重新调用加载函数
    },
    methods: {
        back() {
            this.$router.go(-1); //返回上一层
        },

        inputUploader(up) {
            this.up = up;
            this.files = up.files;
        },
        filesAdded(up, files) {
            files.forEach(f => {
                f.status = -1;
                FileMd5(f.getNative(), (e, md5) => {
                    f['md5'] = md5;
                    f.status = 1;
                });
            });
        },
        deleteFile(id) {
            let file = this.up.getFile(id);
            this.up.removeFile(file);
        },
        removeAllFile() {
            this.up.files.forEach(f => {
                this.deleteFile(f.id);
            });
        },
        beforeUpload(up, file) {
            up.setOption('multipart_params', { size: file.size, md5: file.md5 });
        },
        uploadStart() {
            this.uploading = true;
            this.up.start();
        },
        uploadStop() {
            this.uploading = false;
            this.up.stop();
        },
        error() {
            this.uploading = false;
        },
        uploadComplete() {
            this.uploading = false;
            console.log('上传后回调', this.tableData[0].status);
            if (this.tableData[0].status === 5) {
                this.handleUpdateVersioStatus();
            } else if (this.tableData[0].status === 4) {
            }
        },
        //每个次切片文件上产返回值
        fileUploaded(up, files, info) {
            var res = JSON.parse(info.response);
            if (res.code === 0 && res.data != null) {
                this.updateVersionDetail.downloadUrl = res.data;
                console.log('上传文件返回URL', res.data);
            }
        },
        //其他页面跳转过来的参数
        getParam() {
            var param = this.$route.query;
            this.currentVersionId = param.currentVersionId;
            this.currentVersionNo = param.currentVersionNo;
            this.updateVersionNo = param.updateVersionNo;
            this.projectName = param.projectName;
            console.log('上产文件接收的参数', param);
        },
        async handleUpdateVersioStatus() {
            this.updateVersionDetail.detailId = this.currentVersionId;
            (this.updateVersionDetail.status = 2), (this.updateVersionDetail.fileName = this.tableData[0].name);
            var num = this.tableData[0].size / 1024 / 1024;
            var flag = false;
            if (num < 0.01) {
                flag = true;
                num = this.tableData[0].size / 1024;
            }
            this.updateVersionDetail.fileSize = num.toFixed(2) + '' + (flag == true ? 'Kb' : 'M');
            if (this.tableData[0].md5 != null) {
                this.updateVersionDetail.md5 = this.tableData[0].md5;
                
            }
            this.updateVersionDetail.size=this.tableData[0].size;
            console.log('请求参数updateVersionDetail', this.updateVersionDetail);
            const { data: res } = await updateVersionDetailStatus(this.updateVersionDetail);
            console.log('更新文件', res);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            } else {
                this.back();
                this.removeAllFile();
            }
        }
    }
};
</script>

<style scoped>
</style>
